import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./TierStatus.module.scss";
export const TierStatus = ({ status, label, confirmIcon, denyIcon, isHighLightened, }) => {
    const imageUrls = {
        yes: confirmIcon,
        no: denyIcon,
        other: "",
    };
    const imageUrl = imageUrls[status];
    return (_jsx("div", { className: classNames(styles.tierStatus, {
            [styles.highlight]: isHighLightened,
        }), children: status === "other" ? label : _jsx("img", { alt: "", className: styles.image, src: imageUrl }) }));
};
//# sourceMappingURL=TierStatus.js.map